import type { FC } from "react"
import { useController } from "react-hook-form"

import { AerosSelect } from "@/components/UiKit/AerosSelect/AerosSelect"
import type { SalesOrderLogisticsFormValues } from "@/screens/CustomerOrders/schemas"
import type { Option } from "@/types/form-fields"

interface SalesOrderLineQuantityUomSelectProps {
  index: number
  options: Option<string>[]
  disabled?: boolean
}

const borderlessSelectSx = {
  minWidth: "60px",
  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
  "& .MuiSelect-select": { padding: "2px 4px" },
}

export const SalesOrderLineQuantityUomSelect: FC<SalesOrderLineQuantityUomSelectProps> = ({
  index,
  options,
  disabled = false,
}) => {
  const { field } = useController<SalesOrderLogisticsFormValues, `lines.${number}.uomId`>({
    name: `lines.${index}.uomId`,
  })

  const value = options.some((option) => option.value === field.value) ? field.value : null

  return (
    <AerosSelect
      size='small'
      options={options}
      disabled={disabled}
      value={value}
      onChange={field.onChange}
      sx={borderlessSelectSx}
      data-testid={`customer-orders.so-line-items.uom-field-${index}`}
    />
  )
}
